import * as React from "react";
import { renderInternalEvents } from "../renderInternalEvents";
import { LazyRender } from "sb-resp-ui";
import { EventsFromTopLeaguesBySportIdRequest } from "sb-bff-integration";
export class RenderEvents extends React.PureComponent {
    render() {
        let view = [];
        const eventsLength = this.props.events.length;
        const eventToShow = Math.min(eventsLength, this.props.cms.ExpandedEvents);
        let currChunk = 0;
        for (let current = 0; current < eventToShow;) {
            let baseMinHeight = this.props.eventChunkHeights[currChunk++];
            let start = current;
            let max = current + this.props.state.EVENTS_CHUNK_SIZE;
            current = Math.min(max, eventToShow);
            view.push(React.createElement(LazyRender, { baseMinHeight: baseMinHeight, key: `k-lazy-${current}`, observerOptions: {
                    threshold: 0,
                    rootMargin: "100px 0px"
                } }, renderInternalEvents(this.props.state, current, start, this.props.events, this.props.cms, this.props.dict)));
        }
        let filteredEvents = this.props.events.filter(x => x.type === EventsFromTopLeaguesBySportIdRequest.EventTypesEnum.Outright.toString());
        eventToShow < eventsLength && !this.props.cms.ShowViewAllLive && !filteredEvents.length && view.push(this.props.children);
        return view;
    }
}
//# sourceMappingURL=RenderEvents.js.map